/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { EdiDeliveryProtocol } from "./EdiDeliveryProtocol";
import {
  EdiDeliveryProtocolFromJSON,
  EdiDeliveryProtocolFromJSONTyped,
  EdiDeliveryProtocolToJSON,
  EdiDeliveryProtocolToJSONTyped,
} from "./EdiDeliveryProtocol";
import type { EdiInvoiceSendTiming } from "./EdiInvoiceSendTiming";
import {
  EdiInvoiceSendTimingFromJSON,
  EdiInvoiceSendTimingFromJSONTyped,
  EdiInvoiceSendTimingToJSON,
  EdiInvoiceSendTimingToJSONTyped,
} from "./EdiInvoiceSendTiming";

/**
 * A company's outbound EDI delivery settings, as shown in Hubble. The password is deliberately absent --- once stored it is never read back out to a client, only replaced. \[passwordSet\] is enough for an operator to know whether one is on file.
 * @export
 * @interface EdiDeliverySettingsResponse
 */
export interface EdiDeliverySettingsResponse {
  /**
   *
   * @type {string}
   * @memberof EdiDeliverySettingsResponse
   */
  companyId: string;
  /**
   *
   * @type {EdiDeliveryProtocol}
   * @memberof EdiDeliverySettingsResponse
   */
  protocol: EdiDeliveryProtocol;
  /**
   *
   * @type {string}
   * @memberof EdiDeliverySettingsResponse
   */
  host: string;
  /**
   *
   * @type {number}
   * @memberof EdiDeliverySettingsResponse
   */
  port: number;
  /**
   *
   * @type {string}
   * @memberof EdiDeliverySettingsResponse
   */
  username: string;
  /**
   *
   * @type {boolean}
   * @memberof EdiDeliverySettingsResponse
   */
  passwordSet: boolean;
  /**
   *
   * @type {string}
   * @memberof EdiDeliverySettingsResponse
   */
  directory: string;
  /**
   *
   * @type {string}
   * @memberof EdiDeliverySettingsResponse
   */
  trackingDirectory?: string | null;
  /**
   *
   * @type {EdiInvoiceSendTiming}
   * @memberof EdiDeliverySettingsResponse
   */
  invoiceSendTiming: EdiInvoiceSendTiming;
  /**
   *
   * @type {boolean}
   * @memberof EdiDeliverySettingsResponse
   */
  enabled: boolean;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof EdiDeliverySettingsResponse
   */
  lastSuccessAt?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof EdiDeliverySettingsResponse
   */
  lastError?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof EdiDeliverySettingsResponse
   */
  lastErrorAt?: OffsetDateTime | null;
}

/**
 * Check if a given object implements the EdiDeliverySettingsResponse interface.
 */
export function instanceOfEdiDeliverySettingsResponse(
  value: object,
): value is EdiDeliverySettingsResponse {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (!("protocol" in value) || value["protocol"] === undefined) return false;
  if (!("host" in value) || value["host"] === undefined) return false;
  if (!("port" in value) || value["port"] === undefined) return false;
  if (!("username" in value) || value["username"] === undefined) return false;
  if (!("passwordSet" in value) || value["passwordSet"] === undefined)
    return false;
  if (!("directory" in value) || value["directory"] === undefined) return false;
  if (
    !("invoiceSendTiming" in value) ||
    value["invoiceSendTiming"] === undefined
  )
    return false;
  if (!("enabled" in value) || value["enabled"] === undefined) return false;
  return true;
}

export function EdiDeliverySettingsResponseFromJSON(
  json: any,
): EdiDeliverySettingsResponse {
  return EdiDeliverySettingsResponseFromJSONTyped(json, false);
}

export function EdiDeliverySettingsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EdiDeliverySettingsResponse {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"],
    protocol: EdiDeliveryProtocolFromJSON(json["protocol"]),
    host: json["host"],
    port: json["port"],
    username: json["username"],
    passwordSet: json["passwordSet"],
    directory: json["directory"],
    trackingDirectory:
      json["trackingDirectory"] == null ? undefined : json["trackingDirectory"],
    invoiceSendTiming: EdiInvoiceSendTimingFromJSON(json["invoiceSendTiming"]),
    enabled: json["enabled"],
    lastSuccessAt:
      json["lastSuccessAt"] == null ? undefined : json["lastSuccessAt"],
    lastError: json["lastError"] == null ? undefined : json["lastError"],
    lastErrorAt: json["lastErrorAt"] == null ? undefined : json["lastErrorAt"],
  };
}

export function EdiDeliverySettingsResponseToJSON(
  json: any,
): EdiDeliverySettingsResponse {
  return EdiDeliverySettingsResponseToJSONTyped(json, false);
}

export function EdiDeliverySettingsResponseToJSONTyped(
  value?: EdiDeliverySettingsResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
    protocol: EdiDeliveryProtocolToJSON(value["protocol"]),
    host: value["host"],
    port: value["port"],
    username: value["username"],
    passwordSet: value["passwordSet"],
    directory: value["directory"],
    trackingDirectory: value["trackingDirectory"],
    invoiceSendTiming: EdiInvoiceSendTimingToJSON(value["invoiceSendTiming"]),
    enabled: value["enabled"],
    lastSuccessAt: value["lastSuccessAt"],
    lastError: value["lastError"],
    lastErrorAt: value["lastErrorAt"],
  };
}
